(ns teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-identity-modal
  (:require [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.cancel :refer [cancel]]
            [reagent-material-ui.icons.code :refer [code]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]] ;;(h/event-value e)
            [reagent-material-ui.icons.save :refer [save]]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.lr-clearance :as d-lrClearance]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.view-state :as vstate]))




(defn time-conv [rest-time]
  (if (= "" (str rest-time))
    nil
    (str (subs rest-time 6 8) "." (subs rest-time 4 6) "." (subs rest-time 0 4))
    ))


(defn reject-form [!st document]
  (let [!rejectMessage (r/cursor !st [:userDocument-rejectMessage])]
    [mui/grid {:container  true
               :direction  "row"
               :justify    "space-between"
               :spacing    2
               :multiline  true
               :rowsMin    3
               :style      {:paddingRight "5px"}
               :alignItems "flex-start"}
     [mui/grid {:container false :item true :xs 12}
      "Ablehnung Begründung"]
     [mui/grid {:container false :item true :xs 12}
      [mui/text-field {
                       ;:style {:background-color (if (not= (:userDocument-validTo @!st) (:lrClearance-end wop-clearance))  "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :type            "text"
                       :autoOk          true
                       :error           (= "" @!rejectMessage)
                       :helper-text     (if (= "" @!rejectMessage) "Bitte Begründung eingeben" "")
                       :onChange        (fn [e] (swap! !st assoc :userDocument-rejectMessage (h/event-value e)))
                       :label           (str " ")
                       :defaultValue    (str "" (:userDocument-rejectMessage @!st))
                       :InputLabelProps {:disableAnimation true :shrink true}
                       }]
      ]
     ]
    ))


(defn modal [!actual-user {:keys [userDocument-fileName userDocument-path userDocument-isIdentity userDocument-rejected userDocument-rejectMessage uploaded] :as document} !show & [!show-doc-assign-modal]]
  (let [!invalidated (r/cursor vstate/app-state [:lr-list :invalidated])
        !st (r/atom {:reject userDocument-rejected :userDocument-rejectMessage userDocument-rejectMessage})
        !reject (r/cursor !st [:reject])
        !rejectMessage (r/cursor !st [:userDocument-rejectMessage])
        is-cleared? (d-lrClearance/is-cleared (d-user/get-active-clearance @!actual-user))

        {:keys [user-uuid user-lastName user-firstName user-birthday user-identityValid]} @!actual-user]
    (fn []
      [mui/modal
       {
        :aria-labelledby  "simple-modal-title"
        :aria-describedby "simple-modal-description"
        :style            {:display        "flex"
                           :marginRight    "auto"
                           :marginLeft     "auto"
                           :alignItems     "center"
                           :justifyContent "center"}
        :open             (or @!show false)

        }
       [:div
        {
         :class "modal"
         :style {:width 750}}
        [mui/grid {:container  true
                   :direction  "row"
                   :justify    "space-between"
                   :space      3
                   :alignItems "flex-start"}
         [mui/grid
          {:container false :item true :xs 12}
          [:h2 (if (and userDocument-isIdentity user-identityValid)
                 "Identitätsdokument"
                 "Dokument als Identitätsnachweis verwenden! "
                 )
           ]]
         [mui/grid
          {:container false :item true :xs 6}
          [:div
           [mui/typography {} "Filename" [:br] (or userDocument-fileName userDocument-path)]
           [:br]
           [mui/typography {:gutterBottom true}
            (if uploaded (str "hochgeladen am: "
                              (subs uploaded 6 8) "." (subs uploaded 4 6) "." (subs uploaded 0 4) " " (subs uploaded 9 10) ":" (subs uploaded 11 13)
                              ) "")]
           (if @!reject
             [reject-form !st document]
             [mui/typography {} "Bitte überprüfe:"
              [:br] "Name: " [:span {:style {:color "blue"}} "`" user-lastName ", " user-firstName "`"]
              [:br] "Geburtsdatum: " [:span {:style {:color "blue"}} "`" (time-conv user-birthday) "`"]
              [:br]
              ])
           ]]

         [mui/grid
          {:container false :item true :xs 6}
          [:f> backend-file/download-wrapper userDocument-path
           (fn [url]
             [:a {:title "Klick um in neuem Tab zu öffnen" :href url :target "_blank"}
              [backend-file/img {:hash             userDocument-path
                                        :preview? true
                                        :style    {:position "relative" :float "right" :maxWidth "400px" :maxHeight "400px" :paddingBottom "10px" :objectFit "contain"} :alt "Ansicht"}]])]

          ]


         (when (and !show-doc-assign-modal (not is-cleared?))
           [mui/grid {:container false :item true :xs 12}
            [mui/button
             {:variant   "contained"
              :startIcon (r/as-element [code])
              :style     {:marginBottom 10}
              :onClick   (fn []
                           (reset! !show-doc-assign-modal {:showTomId @!show :type :identity})
                           (reset! !show nil))
              }
             "Dokument wählen"]])

         [mui/grid
          {:container false :item true :xs 4}

          [mui/button
           {:variant   "contained"
            :startIcon (r/as-element [keyboard-arrow-left])
            :style     {:marginRight 50}
            :onClick   #(reset! !show nil)
            }
           "Abbrechen"]]



         (cond

           ;; no document
           (not (:userDocument-uuid document)) [mui/grid {:container false :item true :xs 4} [mui/chip {:color "primary" :label (str "Bitte wähle ein Dokument")}]]



           ;; confirm reject
           @!reject
           [mui/grid {:container false :item true :xs 8}
            [mui/button
             {:color   "secondary"
              :variant "contained"
              ;:startIcon (r/as-element [check])
              :style   {:marginRight 50}
              :onClick (fn []
                         (reset! !reject false)
                         (reset! !rejectMessage ""))

              }
             "Nicht ablehnen"]
            [mui/button
             {:color     "primary"
              :style     {:float "right"}
              :variant   "contained"
              :disabled  (or (= "" @!rejectMessage) (= userDocument-rejectMessage @!rejectMessage))
              :startIcon (r/as-element [cancel])
              :onClick   (fn []
                           (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                             {:userDocument-readonly      false
                                                              :userDocument-rejectMessage (:userDocument-rejectMessage @!st)
                                                              :userDocument-rejected      true
                                                              :userDocument-locked        false
                                                              :userDocument-isIdentity    false
                                                              }
                                                             (fn []
                                                               (d-user/>user-edit-field user-uuid {:user-lrWaiting     true
                                                                                                   :user-identityValid false}
                                                                                        (fn []
                                                                                          (d-user/actual-user-invalidate !actual-user)
                                                                                          (reset! !invalidated true)
                                                                                          (reset! !show nil))
                                                                                        ))
                                                             ))
              }
             "Ablehnen speichern"]]


           ;; is actual document
           (and (:userDocument-isIdentity document)
                user-identityValid
                (= (:userDocument-uuid document) (get-in (d-user/get-active-clearance @!actual-user) [:lrClearance-identityDocument :userDocument-uuid])))
           [mui/grid {:container false :item true :xs 6} [mui/button
                                                          {:color     "secondary"
                                                           :variant   "contained"
                                                           :startIcon (r/as-element [cancel])
                                                           :style     {:marginRight 50}
                                                           :onClick   #(reset! !reject true)
                                                           }
                                                          "Aktives Dokument Ablehnen"]]

           ;; new document
           (or
             (not user-identityValid)
             (not (:userDocument-isIdentity document))
             (not= (:userDocument-uuid document) (get-in (d-user/get-active-clearance @!actual-user) [:lrClearance-identityDocument :userDocument-uuid])))
           [mui/grid
            {:container false :item true :xs 8}
            [mui/button
             {:color     "secondary"
              :variant   "contained"
              :startIcon (r/as-element [cancel])
              :style     {:marginRight 50}
              :onClick   #(reset! !reject true)
              }
             "Ablehnen"]
            [mui/button
             {:color     "primary"
              :style     {:float "right"}
              :variant   "contained"
              :startIcon (r/as-element [save])
              :onClick   (fn []
                           (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                             {:userDocument-readonly      true
                                                              :userDocument-isIdentity    true
                                                              :userDocument-type          "identification"
                                                              :userDocument-rejectMessage ""
                                                              :userDocument-rejected      false
                                                              }
                                                             (fn []
                                                               (d-lrClearance/>user-add-edit-clearance (:user-uuid @!actual-user)
                                                                                                       {:_identityDocument-uuid (:userDocument-uuid document)}
                                                                                                       (fn []
                                                                                                         (d-user/actual-user-invalidate !actual-user)
                                                                                                         (reset! !invalidated true)
                                                                                                         (reset! !show nil)
                                                                                                         ))
                                                               (d-user/>user-edit-field user-uuid {:user-identityValid true}
                                                                                        (fn []
                                                                                          (d-user/actual-user-invalidate !actual-user)
                                                                                          (reset! !invalidated true)
                                                                                          (reset! !show nil)
                                                                                          )))))
              }
             "VERWENDEN"]
            ]

           )





         [:pre {:class "hidden-info" :style {
                                             :display "none"
                                             }}
          "@!reject " @!reject [:br]
          (get-in (d-user/get-active-clearance @!actual-user) [:lrClearance-identityDocument :userDocument-uuid]) "==" (:userDocument-uuid document) [:br]
          ;(h/pretty-map (d-user/get-active-clearance @!actual-user))
          ]

         ]]
       ])
    ))




(defn get-user-details [!actual-user tomId]
  (d-user/get-user-all tomId (fn [data] (reset! !actual-user data)))
  )

(defn modal-by-tomId [!tomId !document-uuid & [!show-doc-assign-modal]]
  (let [!actual-user (r/atom {})]
    (fn []
      (let [user @!actual-user
            tomId @!tomId
            document-uuid @!document-uuid]
        (js/console.log "render identity modal-by-tomId " tomId document-uuid (:reqTomId user))
        (when (and (pos? tomId) (not= tomId (:reqTomId user))) (get-user-details !actual-user tomId))
        (if (or (not= @!tomId (:reqTomId user)) (:error user))
          ;no data
          [mui/modal
           {:aria-labelledby  "simple-modal-title"
            :aria-describedby "simple-modal-description"
            :style            {:display        "flex"
                               :marginRight    "auto"
                               :marginLeft     "auto"
                               :alignItems     "center"
                               :justifyContent "center"}
            :open             (pos? tomId)
            :onClose          (fn []
                                (reset! !actual-user nil)
                                (reset! !tomId nil))
            }
           [:div
            {:class "modal"
             :style {:width 400}}
            [:h4 (str "Identität bestätigen: " tomId)]
            [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
            [mui/typography "Lade den Datensatz ... "]
            [mui/typography {:color "primary"} (:error user)]
            [:br]
            [mui/button
             {:color    "primary"
              :variant  "contained"
              :on-click (fn []
                          (reset! !actual-user {})
                          (reset! !tomId nil))
              }
             "Schließen"]
            ]]
          ;has data
          (let [document (first (filter (fn [e]
                                          ;(js/console.log "##################################### " (:userDocument-active e) (:userDocument-uuid e) document-uuid)
                                          (and (= (:userDocument-uuid e) document-uuid))) (:user-userDocument @!actual-user)))]
            [(modal !actual-user document !tomId !show-doc-assign-modal)]
            )

          )))))